/**
 * Injects primary section "Temporäre Mietänderung" (index 5) into the tenant unit contract editor.
 * @param {{ unitContractId: number | null, propertyHrId?: string | null }} ctx
 */
const injectRentFreePeriods = (ctx) => {
  const SECTION_ID = 'RentFreePeriods'
  if (document.getElementById(SECTION_ID)) return

  const unitContractId = ctx?.unitContractId ?? null
  const propertyHrId = ctx?.propertyHrId ?? null
  if (unitContractId == null) return

  const tenantEditor = document.querySelector('.TenantContractEditor')
  if (!tenantEditor) return

  const pageContent =
    tenantEditor.querySelector('.PageContent[data-testid="page-content-undefined"]') ||
    tenantEditor.querySelector('.PageContent')
  if (!pageContent) return

  const root = document.createElement('div')
  root.className = 'PrimarySectionWrapper RentFreePeriods'
  root.id = SECTION_ID
  root.setAttribute('data-testid', 'primary-section-wrapper-RentFreePeriods')

  const wrapperContent = document.createElement('div')
  wrapperContent.className = 'section-wrapper-content'

  const header = document.createElement('div')
  header.className = 'section-header'
  header.setAttribute('role', 'button')
  header.setAttribute('tabindex', '0')

  const titleWrapper = document.createElement('div')
  titleWrapper.className = 'section-title-wrapper'

  const numberWrap = document.createElement('div')
  numberWrap.className = 'section-number-wrapper'
  const numberEl = document.createElement('div')
  numberEl.className = 'section-number'
  numberEl.textContent = '5'
  numberWrap.appendChild(numberEl)

  const titleEl = document.createElement('div')
  titleEl.className = 'section-title'
  titleEl.textContent = 'Temporäre Mietänderung'

  titleWrapper.appendChild(numberWrap)
  titleWrapper.appendChild(titleEl)
  header.appendChild(titleWrapper)

  const sectionBody = document.createElement('div')
  sectionBody.className = 'section-content section-content-with-padding'
  sectionBody.style.display = 'none'

  const validationError = document.createElement('div')
  validationError.setAttribute('role', 'alert')
  validationError.className = 'RentFreePeriods-validation-error'
  validationError.style.cssText =
    'display:none;margin-top:12px;padding:8px 12px;border-radius:6px;background:#fff2f0;border:1px solid #ffccc7;color:#cf1322;font-size:14px;line-height:1.5;'

  const validationWarning = document.createElement('div')
  validationWarning.setAttribute('role', 'status')
  validationWarning.className = 'RentFreePeriods-validation-warning'
  validationWarning.style.cssText =
    'display:none;margin-top:12px;padding:8px 12px;border-radius:6px;background:#fffbe6;border:1px solid #ffe58f;color:#ad6800;font-size:14px;line-height:1.5;'

  const skeletonEl = document.createElement('div')
  skeletonEl.id = 'RentFreePeriods-skeleton'
  skeletonEl.className = 'RentFreePeriods-skeleton'
  skeletonEl.setAttribute('aria-busy', 'true')
  skeletonEl.style.display = 'none'
  skeletonEl.innerHTML = `
    <div class="RentFreePeriods-skeleton-toolbar">
      <div class="RentFreePeriods-skeleton-bar" style="width:160px;height:32px;margin-left:auto;"></div>
    </div>
    <div class="RentFreePeriods-skeleton-table">
      <div class="RentFreePeriods-skeleton-bar" style="height:40px;margin-bottom:8px;"></div>
      <div class="RentFreePeriods-skeleton-bar" style="height:44px;margin-bottom:6px;"></div>
      <div class="RentFreePeriods-skeleton-bar" style="height:44px;margin-bottom:6px;"></div>
      <div class="RentFreePeriods-skeleton-bar" style="height:44px;"></div>
    </div>
  `

  const contentLoadedWrap = document.createElement('div')
  contentLoadedWrap.className = 'RentFreePeriods-loaded'
  contentLoadedWrap.style.display = 'none'

  const toolbar = document.createElement('div')
  toolbar.style.cssText = 'display:flex;justify-content:flex-end;margin-bottom:12px;'

  const addRowBtn = document.createElement('button')
  addRowBtn.type = 'button'
  addRowBtn.className = 'ant-btn ant-btn-default Button undefined'
  addRowBtn.innerHTML = `
    <span role="img" class="anticon" style="display:inline-flex;margin-right:8px;">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="currentColor"></path>
      </svg>
    </span>
    <span>Zeitraum hinzufügen</span>
  `
  toolbar.appendChild(addRowBtn)

  const tableRoot = document.createElement('div')
  tableRoot.className = 'ant-table ant-table-fixed-header'
  tableRoot.id = 'RentFreePeriodsTable'

  const tableContainer = document.createElement('div')
  tableContainer.className = 'ant-table-container'

  const scrollWrap = document.createElement('div')
  scrollWrap.className = 'ant-table-body RentFreePeriods-table-scroll'
  scrollWrap.style.cssText =
    'background:#fff;border:2px solid #f0f0f0;border-radius:6px;'

  const table = document.createElement('table')
  table.style.cssText =
    'width:100%;min-width:1180px;table-layout:fixed;background:#fff;border-collapse:separate;border-spacing:0;'

  const colgroup = document.createElement('colgroup')
  ;[
    { width: '148px' },
    { width: '148px' },
    { width: '96px' },
    { width: '420px' },
    { width: '76px' },
    { width: '108px' },
    { width: '132px' },
  ].forEach((spec) => {
    const col = document.createElement('col')
    col.style.width = spec.width
    colgroup.appendChild(col)
  })

  const thead = document.createElement('thead')
  thead.className = 'ant-table-thead'
  const headTr = document.createElement('tr')
  ;['Startdatum', 'Enddatum', 'Betrag', 'Konten', 'Monatlich', 'Status', ''].forEach((label) => {
    const th = document.createElement('th')
    th.className = 'ant-table-cell'
    th.textContent = label
    headTr.appendChild(th)
  })
  thead.appendChild(headTr)

  const tbody = document.createElement('tbody')
  tbody.className = 'ant-table-tbody'

  table.appendChild(colgroup)
  table.appendChild(thead)
  table.appendChild(tbody)
  scrollWrap.appendChild(table)
  tableContainer.appendChild(scrollWrap)
  tableRoot.appendChild(tableContainer)

  contentLoadedWrap.appendChild(toolbar)
  contentLoadedWrap.appendChild(tableRoot)
  contentLoadedWrap.appendChild(validationError)
  contentLoadedWrap.appendChild(validationWarning)
  sectionBody.appendChild(skeletonEl)
  sectionBody.appendChild(contentLoadedWrap)

  const footer = document.createElement('div')
  footer.className = 'section-footer'
  footer.style.display = 'none'

  const saveBtn = document.createElement('button')
  saveBtn.type = 'button'
  saveBtn.className = 'ant-btn ant-btn-primary Button undefined'
  const saveSpan = document.createElement('span')
  saveSpan.textContent = 'Speichern'
  saveBtn.appendChild(saveSpan)
  footer.appendChild(saveBtn)

  let isOpen = false
  let nextRowId = 0

  const authToken = () => {
    try {
      const raw = localStorage.getItem('auth')
      return raw ? JSON.parse(raw).token : null
    } catch {
      return null
    }
  }

  const apiRoot = typeof baseApiUrl !== 'undefined' && baseApiUrl ? baseApiUrl : ''

  /** Same as server `IMPOWER_ACCOUNT_CODE_REGEX`. */
  const ACCOUNT_CODE_RE = /^\d+(\/\d+)*$/
  const DEFAULT_EXPENSE_CODE = '60/0/3'

  /** @type {{ accounts60: {code:string,name:string}[], accounts2001: {code:string,name:string}[], autoTenantCode: string|null, autoExpenseCode: string, fromTree?: boolean } | null} */
  let accountCatalog = null
  /** @type {Promise<typeof accountCatalog> | null} */
  let accountCatalogPromise = null

  const FALLBACK_ACCOUNT_CATALOG = {
    accounts60: [{ code: DEFAULT_EXPENSE_CODE, name: 'Temporäre Mietänderung' }],
    accounts2001: [],
    autoTenantCode: null,
    autoExpenseCode: DEFAULT_EXPENSE_CODE,
    fromTree: false,
  }

  const ART_REDUCTION = 'mietminderung'
  const ART_INCREASE = 'mieterhoehung'

  const isSixtyFamily = (code) => {
    const c = String(code || '')
    return c === '60' || c.startsWith('60/')
  }
  const is2001Family = (code) => {
    const c = String(code || '')
    return c === '2001' || c.startsWith('2001/')
  }

  const inferArt = (sollCode, habenCode) => {
    if (is2001Family(sollCode) || isSixtyFamily(habenCode)) return ART_INCREASE
    return ART_REDUCTION
  }

  const getRowArt = (row) =>
    row?.artInput?.value === ART_INCREASE ? ART_INCREASE : ART_REDUCTION

  const formatAccountOptionLabel = (code, name) =>
    name ? `${code} ${name}` : code

  const flattenLeafAccounts = (tree) => {
    const out = []
    const walk = (node) => {
      if (node?.leaf && node.code) {
        out.push({
          code: String(node.code),
          name: node.name ? String(node.name) : '',
          unitContractId: node.unitContractId != null ? Number(node.unitContractId) : null,
        })
      }
      for (const sub of node?.subAccounts ?? []) walk(sub)
    }
    for (const root of tree ?? []) walk(root)
    return out
  }

  const collectLeavesUnder = (node) => {
    const out = []
    const walk = (n) => {
      if (n?.leaf && n.code) {
        out.push({
          code: String(n.code),
          name: n.name ? String(n.name) : '',
          unitContractId: n.unitContractId != null ? Number(n.unitContractId) : null,
        })
      }
      for (const sub of n?.subAccounts ?? []) walk(sub)
    }
    if (node) walk(node)
    return out
  }

  /** Tenant root under 2001 whose unitContractId matches this contract. */
  const findTenantRootNode = (tree, contractId) => {
    const cid = Number(contractId)
    const walk = (node) => {
      if (Number(node.unitContractId) === cid && node.code) return node
      for (const sub of node.subAccounts ?? []) {
        const found = walk(sub)
        if (found) return found
      }
      return null
    }
    const roots = tree ?? []
    const root2001 = roots.find((n) => String(n.code) === '2001')
    if (root2001) {
      const found = walk(root2001)
      if (found) return found
    }
    for (const root of roots) {
      const found = walk(root)
      if (found) return found
    }
    return null
  }

  const contract2001Leaves = (tree, leaves) => {
    const cid = Number(unitContractId)
    const tenantRoot = findTenantRootNode(tree, cid)
    const prefix = tenantRoot?.code ? String(tenantRoot.code) : null
    const underRoot = tenantRoot
      ? collectLeavesUnder(tenantRoot).filter((a) => is2001Family(a.code))
      : []
    if (underRoot.length > 0) {
      return underRoot.sort((a, b) => a.code.localeCompare(b.code, 'de', { numeric: true }))
    }
    const fallback = leaves.filter((a) => {
      if (!is2001Family(a.code)) return false
      if (a.unitContractId === cid) return true
      if (prefix && (a.code === prefix || a.code.startsWith(`${prefix}/`))) return true
      return false
    })
    return fallback.sort((a, b) => a.code.localeCompare(b.code, 'de', { numeric: true }))
  }

  const findTenantRentChangeAccountInTree = (tree, contractId) => {
    const cid = Number(contractId)
    const walk = (node) => {
      if (Number(node.unitContractId) === cid && node.code) {
        for (const sub of node.subAccounts ?? []) {
          if (sub.leaf && sub.code?.endsWith('/0/3') && sub.id != null) return String(sub.code)
          if (sub.code?.endsWith('/0') && sub.subAccounts) {
            for (const leaf of sub.subAccounts) {
              if (leaf.leaf && leaf.code?.endsWith('/0/3') && leaf.id != null) return String(leaf.code)
            }
          }
        }
        // Prefer leaf named Temporäre Mietänderung under this contract root
        const named = (node.subAccounts ?? [])
          .flatMap((s) => (s.leaf ? [s] : s.subAccounts ?? []))
          .find(
            (leaf) =>
              leaf.leaf &&
              leaf.id != null &&
              /temporäre mietänderung/i.test(String(leaf.name || ''))
          )
        if (named?.code) return String(named.code)
      }
      for (const sub of node.subAccounts ?? []) {
        const found = walk(sub)
        if (found) return found
      }
      return null
    }
    for (const root of tree) {
      const found = walk(root)
      if (found) return found
    }
    // Fallback: leaf itself carries unitContractId
    const leafMatch = flattenLeafAccounts(tree).find(
      (a) => a.unitContractId === cid && a.code.endsWith('/0/3')
    )
    return leafMatch?.code || null
  }

  const buildAccountCatalog = (tree) => {
    const leaves = flattenLeafAccounts(tree)
    const accounts60 = leaves
      .filter((a) => isSixtyFamily(a.code))
      .sort((a, b) => a.code.localeCompare(b.code, 'de', { numeric: true }))
    const accounts2001 = contract2001Leaves(tree, leaves)
    const autoTenantCode = findTenantRentChangeAccountInTree(tree, unitContractId)
    const expenseDefault =
      accounts60.find((a) => a.code === DEFAULT_EXPENSE_CODE)?.code ||
      accounts60.find((a) => a.code.endsWith('/0/3'))?.code ||
      DEFAULT_EXPENSE_CODE
    return {
      accounts60,
      accounts2001,
      autoTenantCode: autoTenantCode || null,
      autoExpenseCode: expenseDefault,
    }
  }

  const ensureAccountCatalog = async () => {
    // Only a successful tree load is sticky; auth/network failures must retry.
    if (accountCatalog?.fromTree) return accountCatalog
    if (accountCatalogPromise) return accountCatalogPromise
    accountCatalogPromise = (async () => {
      if (!propertyHrId) {
        accountCatalogPromise = null
        return FALLBACK_ACCOUNT_CATALOG
      }
      const token = authToken()
      if (!token) {
        accountCatalogPromise = null
        return FALLBACK_ACCOUNT_CATALOG
      }
      try {
        const res = await fetch(
          `/services/pmp-accounting/api/v1/accounting/account-tree/${encodeURIComponent(propertyHrId)}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (!res.ok) throw new Error('account-tree')
        const tree = await res.json()
        accountCatalog = {
          ...buildAccountCatalog(Array.isArray(tree) ? tree : []),
          fromTree: true,
        }
        return accountCatalog
      } catch {
        accountCatalogPromise = null
        return FALLBACK_ACCOUNT_CATALOG
      }
    })()
    return accountCatalogPromise
  }

  const refreshRowAccountSelects = () => {
    getDataRows().forEach((tr) => {
      const row = tr._rentFreeRow
      if (!row || row.executedAt) return
      const art = getRowArt(row)
      if (art === ART_INCREASE) {
        if (!row.expenseInput.value && accountCatalog?.autoTenantCode) {
          fillAccountSelect(
            row.expenseInput,
            optionsForRole('soll', accountCatalog.autoTenantCode, art),
            accountCatalog.autoTenantCode
          )
        }
        if (!row.tenantInput.value && accountCatalog?.autoExpenseCode) {
          fillAccountSelect(
            row.tenantInput,
            optionsForRole('haben', accountCatalog.autoExpenseCode, art),
            accountCatalog.autoExpenseCode,
            habenEmptyLabel(art)
          )
        }
      } else if (!row.tenantInput.value && accountCatalog?.autoTenantCode) {
        fillAccountSelect(
          row.tenantInput,
          optionsForRole('haben', accountCatalog.autoTenantCode, art),
          accountCatalog.autoTenantCode,
          habenEmptyLabel(art)
        )
      }
      syncAccountPair(row)
    })
  }

  const fetchAutoTenantAccountCode = async () => {
    const catalog = await ensureAccountCatalog()
    return catalog?.autoTenantCode || null
  }

  const ensureOptionPresent = (list, code, name = '') => {
    if (!code) return list
    if (list.some((a) => a.code === code)) return list
    return [{ code, name }, ...list]
  }

  const optionsForRole = (role, ownCode, art) => {
    const catalog = accountCatalog || FALLBACK_ACCOUNT_CATALOG
    const increase = art === ART_INCREASE
    const list =
      role === 'soll'
        ? increase
          ? catalog.accounts2001
          : catalog.accounts60
        : increase
          ? catalog.accounts60
          : catalog.accounts2001
    return ensureOptionPresent(list, ownCode)
  }

  const fillAccountSelect = (select, options, selectedCode, emptyLabel = 'Konto wählen…') => {
    const prev = selectedCode || select.value
    select.replaceChildren()
    const empty = document.createElement('option')
    empty.value = ''
    empty.textContent = emptyLabel
    select.appendChild(empty)
    for (const opt of options) {
      const o = document.createElement('option')
      o.value = opt.code
      o.textContent = formatAccountOptionLabel(opt.code, opt.name)
      o.title = o.textContent
      select.appendChild(o)
    }
    if (prev && [...select.options].some((o) => o.value === prev)) {
      select.value = prev
    } else {
      select.value = ''
    }
  }

  const habenEmptyLabel = (art) => {
    if (art === ART_INCREASE) return 'Konto wählen…'
    return accountCatalog?.autoTenantCode
      ? `Automatisch (${accountCatalog.autoTenantCode})`
      : 'Automatisch (Mieter …/0/3)'
  }

  const syncAccountPair = (row) => {
    const art = getRowArt(row)
    const sollCode = row.expenseInput.value
    const habenCode = row.tenantInput.value
    fillAccountSelect(
      row.expenseInput,
      optionsForRole('soll', sollCode, art),
      sollCode
    )
    fillAccountSelect(
      row.tenantInput,
      optionsForRole('haben', habenCode, art),
      habenCode,
      habenEmptyLabel(art)
    )
  }

  const applyArtSwap = (row) => {
    const art = getRowArt(row)
    const prevSoll = row.expenseInput.value
    const prevHaben = row.tenantInput.value
    let nextSoll = prevHaben
    let nextHaben = prevSoll
    if (art === ART_INCREASE) {
      if (!nextSoll) nextSoll = accountCatalog?.autoTenantCode || ''
      if (!nextHaben) nextHaben = accountCatalog?.autoExpenseCode || DEFAULT_EXPENSE_CODE
    } else if (!nextSoll) {
      nextSoll = accountCatalog?.autoExpenseCode || DEFAULT_EXPENSE_CODE
    }
    fillAccountSelect(
      row.expenseInput,
      optionsForRole('soll', nextSoll, art),
      nextSoll
    )
    fillAccountSelect(
      row.tenantInput,
      optionsForRole('haben', nextHaben, art),
      nextHaben,
      habenEmptyLabel(art)
    )
  }

  const defaultBalanceDateRange = () => {
    try {
      const raw = localStorage.getItem('lux_balanceDateRange')
      if (raw) {
        const { startDate, endDate } = JSON.parse(raw)
        if (startDate && endDate) return { startDate, endDate }
      }
    } catch (_) {
      /* ignore */
    }
    const y = new Date().getFullYear()
    return { startDate: `${y}-01-01`, endDate: `${y}-12-31` }
  }

  const rowBalanceDateRange = (row) => {
    const start = row.startInput.getValue()
    const end = row.endInput.getValue()
    const today = new Date()
    const todayYmd = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    if (start && /^\d{4}-\d{2}-\d{2}$/.test(start)) {
      const endYmd = end && /^\d{4}-\d{2}-\d{2}$/.test(end) ? end : todayYmd
      return { startDate: start, endDate: endYmd }
    }
    return defaultBalanceDateRange()
  }

  const buildKontenblattHref = (accountCode, startDate, endDate) => {
    if (!propertyHrId || !accountCode) return null
    const params = new URLSearchParams({ startDate, endDate })
    const encodedProperty = encodeURIComponent(propertyHrId)
    const encodedAccount = encodeURIComponent(accountCode)
    if (window.location.pathname.startsWith('/dashboard')) {
      return `/dashboard/account-sheet/property/${encodedProperty}/account/${encodedAccount}?${params}`
    }
    return `/account-balances/${encodedProperty}/account/${encodedAccount}?${params}`
  }

  const resolveHabenAccountCode = async (row) => {
    const fromInput = row.tenantInput.value.trim()
    if (fromInput && ACCOUNT_CODE_RE.test(fromInput)) return fromInput
    return fetchAutoTenantAccountCode()
  }

  const resolveSollAccountCode = (row) => {
    const code = row.expenseInput.value.trim() || DEFAULT_EXPENSE_CODE
    return ACCOUNT_CODE_RE.test(code) ? code : null
  }

  const setBookingsAnchor = (anchor, side, accountCode, href) => {
    if (!anchor) return
    const listItem = anchor.closest('li')
    if (!href) {
      anchor.style.display = 'none'
      anchor.removeAttribute('href')
      anchor.replaceChildren()
      if (listItem) listItem.style.display = 'none'
      return
    }
    if (listItem) listItem.style.display = ''
    anchor.href = href
    anchor.target = '_blank'
    anchor.rel = 'noopener noreferrer'
    anchor.className = 'RentFreePeriods-bookings-chip'
    anchor.title = accountCode
      ? `${side}-Konto ${accountCode} im Kontenblatt öffnen`
      : `${side} im Kontenblatt öffnen`
    anchor.replaceChildren()
    const tag = document.createElement('span')
    tag.className = 'RentFreePeriods-bookings-chip-side'
    tag.textContent = side
    const codeEl = document.createElement('span')
    codeEl.className = 'RentFreePeriods-bookings-chip-code'
    codeEl.textContent = accountCode || '…'
    anchor.appendChild(tag)
    anchor.appendChild(codeEl)
    anchor.style.display = 'inline-flex'
  }

  const updateRowBookingsLink = async (tr) => {
    const row = tr._rentFreeRow
    if (!row?.sollBookingsLink) return
    if (!row.executedAt) {
      setBookingsAnchor(row.sollBookingsLink, 'Soll', null, null)
      setBookingsAnchor(row.habenBookingsLink, 'Haben', null, null)
      if (row.bookingsLinksWrap) row.bookingsLinksWrap.style.display = 'none'
      return
    }
    const sollCode = resolveSollAccountCode(row)
    const habenCode = await resolveHabenAccountCode(row)
    const { startDate, endDate } = rowBalanceDateRange(row)
    const sollHref = sollCode ? buildKontenblattHref(sollCode, startDate, endDate) : null
    const habenHref = habenCode ? buildKontenblattHref(habenCode, startDate, endDate) : null
    setBookingsAnchor(row.sollBookingsLink, 'Soll', sollCode, sollHref)
    setBookingsAnchor(row.habenBookingsLink, 'Haben', habenCode, habenHref)
    const showLinks = !!(sollHref || habenHref)
    if (row.bookingsLinksWrap) {
      row.bookingsLinksWrap.style.display = showLinks ? '' : 'none'
    }
  }

  const refreshAllBookingsLinks = () => {
    getDataRows().forEach((tr) => {
      updateRowBookingsLink(tr)
    })
  }

  const formatEuroDisplay = (amountEur) => {
    const n = typeof amountEur === 'string' ? parseFloat(amountEur) : Number(amountEur)
    if (!Number.isFinite(n)) return ''
    return n.toFixed(2).replace('.', ',')
  }

  const parseEuroInput = (s) => {
    const n = Number(String(s).replace(/\./g, '').replace(',', '.'))
    return Number.isFinite(n) && n >= 0 ? n : null
  }

  const parseIsoDate = (iso) => {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null
    const [y, m, d] = iso.split('-').map(Number)
    const dt = new Date(y, m - 1, d)
    return Number.isNaN(dt.getTime()) ? null : dt
  }

  const inclusiveOverlap = (aStart, aEnd, bStart, bEnd) =>
    aStart.getTime() <= bEnd.getTime() && bStart.getTime() <= aEnd.getTime()

  const getDataRows = () => [...tbody.querySelectorAll('tr[data-rent-free-row]')]

  const PLACEHOLDER_ROW_ATTR = 'data-rent-free-placeholder'

  const refreshRentFreeEmptyState = () => {
    const existing = tbody.querySelector(`tr[${PLACEHOLDER_ROW_ATTR}]`)
    if (getDataRows().length > 0) {
      if (existing) existing.remove()
      return
    }
    if (existing) return

    const tr = document.createElement('tr')
    tr.className = 'ant-table-placeholder'
    tr.setAttribute(PLACEHOLDER_ROW_ATTR, 'true')

    const td = document.createElement('td')
    td.className = 'ant-table-cell'
    td.colSpan = 7

    const outer = document.createElement('div')
    outer.className = 'EmptyTableMultilineMessageContainer'
    const empty = document.createElement('div')
    empty.className = 'ant-empty EmptyTableMultilineMessage'
    const descWrap = document.createElement('div')
    descWrap.className = 'ant-empty-description'
    const desc = document.createElement('div')
    desc.className = 'description'
    desc.innerHTML =
      'Sie haben noch keine temporären Mietänderungen angelegt.<br />Sie können diese über den Button oben hinzufügen.'
    descWrap.appendChild(desc)
    empty.appendChild(descWrap)
    outer.appendChild(empty)
    td.appendChild(outer)
    tr.appendChild(td)
    tbody.appendChild(tr)
  }

  const readRowPeriod = (tr) => {
    const row = tr._rentFreeRow
    if (!row) return null
    const startIso = row.startInput.getValue()
    const endIso = row.endInput.getValue()
    const start = parseIsoDate(startIso)
    if (!start) return null
    const end = endIso ? parseIsoDate(endIso) : new Date(9999, 11, 31)
    if (endIso && !parseIsoDate(endIso)) return null
    return { tr, start, end, recurring: row.recurringInput.checked }
  }

  const setRowErrorState = (tr, hasError) => {
    tr.querySelectorAll('.ant-table-cell').forEach((td) => {
      if (hasError) td.classList.add('RentFreePeriods-cell-error')
      else td.classList.remove('RentFreePeriods-cell-error')
    })
  }

  const validatePeriods = () => {
    getDataRows().forEach((tr) => setRowErrorState(tr, false))
    const periods = []
    for (const tr of getDataRows()) {
      const p = readRowPeriod(tr)
      if (!p) continue
      const endIso = tr._rentFreeRow.endInput.getValue()
      if (!endIso) {
        setRowErrorState(p.tr, true)
        return { ok: false, message: 'Enddatum fehlt.', warning: '' }
      }
      if (endIso && p.start.getTime() > p.end.getTime()) {
        setRowErrorState(p.tr, true)
        return { ok: false, message: 'Das Enddatum muss am oder nach dem Startdatum liegen.', warning: '' }
      }
      periods.push(p)
    }
    let warning = ''
    for (let i = 0; i < periods.length; i++) {
      for (let j = i + 1; j < periods.length; j++) {
        if (inclusiveOverlap(periods[i].start, periods[i].end, periods[j].start, periods[j].end)) {
          warning = 'Hinweis: Temporäre Mietänderungen überschneiden sich.'
        }
      }
    }
    return { ok: true, message: '', warning }
  }

  const showValidation = (message) => {
    if (!message) {
      validationError.style.display = 'none'
      validationError.textContent = ''
      return
    }
    validationError.style.display = 'block'
    validationError.textContent = message
  }

  const showWarning = (message) => {
    if (!message) {
      validationWarning.style.display = 'none'
      validationWarning.textContent = ''
      return
    }
    validationWarning.style.display = 'block'
    validationWarning.textContent = message
  }

  const setAccountFieldError = (input, hasError) => {
    if (!input) return
    input.classList.toggle('RentFreePeriods-account-input-error', hasError)
  }

  const validateRowAccounts = (row) => {
    setAccountFieldError(row.expenseInput, false)
    setAccountFieldError(row.tenantInput, false)
    const art = getRowArt(row)
    const expenseCode = row.expenseInput.value.trim()
    const tenantCode = row.tenantInput.value.trim()
    if (!expenseCode || !ACCOUNT_CODE_RE.test(expenseCode)) {
      setAccountFieldError(row.expenseInput, true)
      return {
        ok: false,
        message:
          art === ART_INCREASE
            ? 'Soll-Konto wählen (2001… dieses Vertrags).'
            : 'Soll-Konto wählen (z. B. 60/0/3).',
      }
    }
    // Empty Haben is only allowed for Mietminderung (server resolves tenant …/0/3).
    if (!tenantCode) {
      if (art === ART_INCREASE) {
        setAccountFieldError(row.tenantInput, true)
        return { ok: false, message: 'Haben-Konto wählen (z. B. 60/0/3).' }
      }
      return { ok: true, expenseCode, tenantCode: null }
    }
    if (!ACCOUNT_CODE_RE.test(tenantCode)) {
      setAccountFieldError(row.tenantInput, true)
      return { ok: false, message: 'Haben-Konto wählen.' }
    }
    const paired =
      art === ART_INCREASE
        ? is2001Family(expenseCode) && isSixtyFamily(tenantCode)
        : isSixtyFamily(expenseCode) && is2001Family(tenantCode)
    if (!paired) {
      setAccountFieldError(row.expenseInput, true)
      setAccountFieldError(row.tenantInput, true)
      return {
        ok: false,
        message:
          art === ART_INCREASE
            ? 'Soll muss 2001… (dieser Vertrag), Haben 60… sein.'
            : 'Soll muss 60…, Haben 2001… (dieser Vertrag) sein.',
      }
    }
    return { ok: true, expenseCode, tenantCode }
  }

  const runValidation = () => {
    const result = validatePeriods()
    showValidation(result.ok ? '' : result.message)
    showWarning(result.ok ? result.warning || '' : '')
    return result
  }

  const wireRowValidation = (tr) => {
    const row = tr._rentFreeRow
    const onChange = () => runValidation()
    row.startInput.addEventListener('change', onChange)
    row.startInput.addEventListener('input', onChange)
    row.endInput.addEventListener('change', onChange)
    row.endInput.addEventListener('input', onChange)
    row.amountInput.addEventListener('input', onChange)
    row.recurringInput.addEventListener('change', onChange)
    const onAccountChange = () => {
      syncAccountPair(row)
      setAccountFieldError(row.expenseInput, false)
      setAccountFieldError(row.tenantInput, false)
      runValidation()
      updateRowBookingsLink(tr)
    }
    row.expenseInput.addEventListener('change', onAccountChange)
    row.tenantInput.addEventListener('change', onAccountChange)
    row.artInput.addEventListener('change', () => {
      applyArtSwap(row)
      setAccountFieldError(row.expenseInput, false)
      setAccountFieldError(row.tenantInput, false)
      runValidation()
      updateRowBookingsLink(tr)
    })
  }

  const mkDateCell = (pickerInput) => {
    const td = document.createElement('td')
    td.className = 'ant-table-cell'
    const wrap = document.createElement('div')
    wrap.className = 'DateInput undefined'
    const formRow = document.createElement('div')
    formRow.className = 'ant-row ant-form-item'
    formRow.style.rowGap = '0'
    const col = document.createElement('div')
    col.className = 'ant-col ant-form-item-control'
    const c1 = document.createElement('div')
    c1.className = 'ant-form-item-control-input'
    const c2 = document.createElement('div')
    c2.className = 'ant-form-item-control-input-content'
    c2.appendChild(pickerInput.wrapper)
    c1.appendChild(c2)
    col.appendChild(c1)
    formRow.appendChild(col)
    wrap.appendChild(formRow)
    td.appendChild(wrap)
    return td
  }

  const applyRowUi = (tr) => {
    const row = tr._rentFreeRow
    if (!row) return
    const executed = !!row.executedAt
    const saved = row.serverId != null
    const locked = executed

    tr.classList.toggle('RentFreePeriods-row-executed', locked)

    if (executed) {
      row.statusEl.textContent = 'Ausgeführt'
      row.statusEl.className = 'RentFreePeriods-status RentFreePeriods-status-done'
    } else if (saved) {
      row.statusEl.textContent = 'Offen'
      row.statusEl.className = 'RentFreePeriods-status RentFreePeriods-status-open'
    } else {
      row.statusEl.textContent = 'Entwurf'
      row.statusEl.className = 'RentFreePeriods-status RentFreePeriods-status-draft'
    }

    row.executeBtn.style.display = saved && !executed ? '' : 'none'
    row.executeBtn.textContent = 'Buchen'
    row.executeBtn.title = 'Sollstellung im Mietänderungs-Unterkonto erstellen'
    row.deleteWrap.style.display = locked ? 'none' : ''

    // After booking, lock fields (postings already exist).
    row.startInput.setDisabled?.(locked)
    row.endInput.setDisabled?.(locked)
    row.amountInput.disabled = locked
    row.expenseInput.disabled = locked
    row.recurringInput.disabled = locked
    row.tenantInput.disabled = locked
    if (row.artInput) row.artInput.disabled = locked

    updateRowBookingsLink(tr)
  }

  /** Build PUT/POST body from current row inputs. Returns null if invalid. */
  const buildRowSaveBody = (row) => {
    const periodStart = row.startInput.getValue()
    const periodEnd = row.endInput.getValue() || null
    const amountNum = parseEuroInput(row.amountInput.value)
    if (!periodStart || !periodEnd || amountNum == null || amountNum <= 0) {
      return { ok: false, message: 'Bitte Start, Ende und Betrag ausfüllen.' }
    }
    const accounts = validateRowAccounts(row)
    if (!accounts.ok) return accounts
    return {
      ok: true,
      body: {
        contract_id: unitContractId,
        period_start: periodStart,
        period_end: periodEnd,
        amount_eur: amountNum,
        expense_account_code: accounts.expenseCode,
        tenant_account_code: accounts.tenantCode,
        recurring_monthly: row.recurringInput.checked,
      },
      accounts,
    }
  }

  /** Persist one saved (or new) row so execute sees the same values as the form. */
  const persistRow = async (row, token) => {
    // Retry account-tree if a prior load failed so Haben options can appear.
    const catalog = await ensureAccountCatalog()
    if (catalog?.fromTree) refreshRowAccountSelects()
    const built = buildRowSaveBody(row)
    if (!built.ok) return built
    if (row.serverId != null) {
      const res = await fetch(
        `${apiRoot}/api/contracts/rent-free-periods/${encodeURIComponent(row.serverId)}`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(built.body),
        }
      )
      const payload = await res.json().catch(() => ({}))
      if (!res.ok) {
        return { ok: false, message: payload.error || 'Speichern fehlgeschlagen.' }
      }
      return { ok: true, accounts: built.accounts, period: payload.period }
    }
    const res = await fetch(`${apiRoot}/api/contracts/rent-free-periods`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(built.body),
    })
    const payload = await res.json().catch(() => ({}))
    if (!res.ok) {
      return { ok: false, message: payload.error || 'Speichern fehlgeschlagen.' }
    }
    if (payload.period?.id != null) {
      row.serverId = Number(payload.period.id)
    }
    return { ok: true, accounts: built.accounts, period: payload.period }
  }

  /**
   * @param {{ serverId?: number|null, periodStart?: string, periodEnd?: string, amountDisplay?: string, expenseAccountCode?: string, tenantAccountCode?: string, recurringMonthly?: boolean, executedAt?: string|null }} opts
   */
  const createRentFreeDataRow = (opts = {}) => {
    const serverId = opts.serverId != null ? Number(opts.serverId) : null
    const rowId = nextRowId++
    const tr = document.createElement('tr')
    tr.className = 'ant-table-row ant-table-row-level-0'
    tr.dataset.rentFreeRow = String(rowId)

    const startInput = datePicker(`rentFreePeriod-start-${rowId}`)
    const endInput = datePicker(`rentFreePeriod-end-${rowId}`)

    const amountWrap = document.createElement('div')
    amountWrap.className = 'NumberInput undefined'
    amountWrap.innerHTML = `
      <div class="ant-row ant-form-item" style="row-gap:0;">
        <div class="ant-col ant-form-item-control">
          <div class="ant-form-item-control-input">
            <div class="ant-form-item-control-input-content">
              <div class="RentFreePeriods-amount-field">
                <input autocomplete="off" class="ant-input Input RentFreePeriods-amount-input" data-lux-rent-free-amount="1" placeholder="0,00" type="text" inputmode="decimal" />
                <span class="RentFreePeriods-amount-suffix">€</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
    const amountInput = amountWrap.querySelector('input')

    const expenseInput = document.createElement('select')
    expenseInput.className = 'ant-input Input RentFreePeriods-account-input RentFreePeriods-account-select'
    expenseInput.title = 'Soll-Konto'

    const tenantInput = document.createElement('select')
    tenantInput.className = 'ant-input Input RentFreePeriods-account-input RentFreePeriods-account-select'
    tenantInput.title = 'Haben-Konto (Mieter)'

    const artInput = document.createElement('select')
    artInput.className = 'ant-input Input RentFreePeriods-account-input RentFreePeriods-account-select RentFreePeriods-art-select'
    artInput.title = 'Art der Mietänderung'
    artInput.setAttribute('aria-label', 'Art der Mietänderung')
    ;[
      { value: ART_REDUCTION, label: 'Mietminderung' },
      { value: ART_INCREASE, label: 'Mieterhöhung' },
    ].forEach((opt) => {
      const o = document.createElement('option')
      o.value = opt.value
      o.textContent = opt.label
      artInput.appendChild(o)
    })

    const catalog = accountCatalog
    const art = inferArt(opts.expenseAccountCode, opts.tenantAccountCode)
    artInput.value = art
    let defaultExpense
    let defaultTenant
    if (art === ART_INCREASE) {
      defaultExpense = opts.expenseAccountCode || catalog?.autoTenantCode || ''
      defaultTenant = opts.tenantAccountCode || catalog?.autoExpenseCode || DEFAULT_EXPENSE_CODE
    } else {
      defaultExpense = opts.expenseAccountCode || catalog?.autoExpenseCode || DEFAULT_EXPENSE_CODE
      defaultTenant = opts.tenantAccountCode || catalog?.autoTenantCode || ''
    }

    fillAccountSelect(
      expenseInput,
      optionsForRole('soll', defaultExpense, art),
      defaultExpense
    )
    fillAccountSelect(
      tenantInput,
      optionsForRole('haben', defaultTenant, art),
      defaultTenant,
      habenEmptyLabel(art)
    )

    const recurringInput = document.createElement('input')
    recurringInput.type = 'checkbox'
    recurringInput.checked = !!opts.recurringMonthly
    recurringInput.title = 'Monatlich wiederkehrend (Start→Ende je Monat buchen)'

    const statusEl = document.createElement('span')
    statusEl.className = 'RentFreePeriods-status RentFreePeriods-status-open'
    statusEl.textContent = 'Offen'

    const executeBtn = document.createElement('button')
    executeBtn.type = 'button'
    executeBtn.className = 'ant-btn ant-btn-default Button undefined'
    executeBtn.textContent = 'Buchen'
    executeBtn.title = 'Sollstellung im Mietänderungs-Unterkonto erstellen'
    executeBtn.addEventListener('click', async () => {
      const rowData = tr._rentFreeRow
      if (rowData.serverId == null || rowData.executedAt) return
      if (!propertyHrId) {
        showValidation('propertyHrId fehlt in der URL.')
        return
      }
      if (!runValidation().ok) return
      const token = authToken()
      if (!token) {
        alert('Nicht angemeldet.')
        return
      }
      executeBtn.disabled = true
      try {
        const saved = await persistRow(rowData, token)
        if (!saved.ok) {
          showValidation(saved.message)
          return
        }
        const accounts = saved.accounts
        const res = await fetch(
          `${apiRoot}/api/contracts/rent-free-periods/${encodeURIComponent(rowData.serverId)}/execute`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              propertyHrId,
              expense_account_code: accounts.expenseCode,
              tenant_account_code: accounts.tenantCode,
            }),
          }
        )
        const payload = await res.json().catch(() => ({}))
        if (!res.ok) throw new Error(payload.error || 'Buchen fehlgeschlagen')
        const bookedExpense =
          payload.period?.expenseAccountCode || payload.period?.expense_account_code
        const bookedTenant =
          payload.period?.tenantAccountCode || payload.period?.tenant_account_code
        if (bookedExpense) {
          fillAccountSelect(
            rowData.expenseInput,
            optionsForRole('soll', bookedExpense, getRowArt(rowData)),
            bookedExpense
          )
        }
        if (bookedTenant) {
          fillAccountSelect(
            rowData.tenantInput,
            optionsForRole('haben', bookedTenant, getRowArt(rowData)),
            bookedTenant,
            habenEmptyLabel(getRowArt(rowData))
          )
        }
        rowData.executedAt = payload.period?.executedAt || new Date().toISOString()
        applyRowUi(tr)
        showValidation('')
        showWarning('')
      } catch (e) {
        showValidation(e.message || 'Buchen fehlgeschlagen.')
      } finally {
        executeBtn.disabled = false
      }
    })

    const deleteBtn = document.createElement('button')
    deleteBtn.type = 'button'
    deleteBtn.className = 'ant-btn ant-btn-ghost Button icon-button undefined trash'
    deleteBtn.setAttribute('aria-label', 'Zeile löschen')
    deleteBtn.innerHTML = `
      <span role="img" class="anticon">
        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3.26 21H14.74L16 7H2L3.26 21ZM13 4V2C13 1.46957 12.7893 0.960859 12.4142 0.585786C12.0391 0.210714 11.5304 0 11 0H7C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V4H0V6H18V4H13ZM11 4H7V2H11V4Z" fill="currentColor"></path>
        </svg>
      </span>
    `
    const deleteWrap = document.createElement('span')
    deleteWrap.className = 'RentFreePeriods-delete-wrap'
    deleteWrap.appendChild(deleteBtn)
    deleteBtn.addEventListener('click', async () => {
      const rowData = tr._rentFreeRow
      if (rowData.executedAt) return
      if (rowData.serverId != null) {
        const token = authToken()
        if (!token) {
          alert('Nicht angemeldet.')
          return
        }
        deleteBtn.disabled = true
        try {
          const res = await fetch(
            `${apiRoot}/api/contracts/rent-free-periods/${encodeURIComponent(rowData.serverId)}`,
            { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }
          )
          if (!res.ok) {
            const err = await res.json().catch(() => ({}))
            throw new Error(err.error || 'Löschen fehlgeschlagen')
          }
        } catch (e) {
          alert(e.message || 'Löschen fehlgeschlagen.')
          deleteBtn.disabled = false
          return
        }
        deleteBtn.disabled = false
      }
      tr.remove()
      runValidation()
      refreshRentFreeEmptyState()
    })

    tr.appendChild(mkDateCell(startInput))
    tr.appendChild(mkDateCell(endInput))

    const amountTd = document.createElement('td')
    amountTd.className = 'ant-table-cell'
    amountTd.appendChild(amountWrap)
    tr.appendChild(amountTd)

    const expenseTd = document.createElement('td')
    expenseTd.className = 'ant-table-cell'
    const accountsWrap = document.createElement('div')
    accountsWrap.className = 'RentFreePeriods-accounts-row'
    const accountsArrow = document.createElement('span')
    accountsArrow.className = 'RentFreePeriods-accounts-arrow'
    accountsArrow.textContent = '→'
    accountsArrow.setAttribute('aria-hidden', 'true')
    accountsWrap.appendChild(artInput)
    accountsWrap.appendChild(expenseInput)
    accountsWrap.appendChild(accountsArrow)
    accountsWrap.appendChild(tenantInput)
    expenseTd.appendChild(accountsWrap)
    tr.appendChild(expenseTd)

    const recurringTd = document.createElement('td')
    recurringTd.className = 'ant-table-cell'
    recurringTd.style.textAlign = 'center'
    recurringTd.appendChild(recurringInput)
    tr.appendChild(recurringTd)

    const statusTd = document.createElement('td')
    statusTd.className = 'ant-table-cell RentFreePeriods-status-td'
    statusTd.appendChild(statusEl)
    tr.appendChild(statusTd)

    const actionTd = document.createElement('td')
    actionTd.className = 'ant-table-cell RentFreePeriods-actions-td'
    const actionInner = document.createElement('div')
    actionInner.className = 'RentFreePeriods-actions-inner'
    const actionButtons = document.createElement('div')
    actionButtons.className = 'RentFreePeriods-actions-buttons'
    actionButtons.appendChild(executeBtn)
    actionButtons.appendChild(deleteWrap)
    const bookingsLinksWrap = document.createElement('div')
    bookingsLinksWrap.className = 'RentFreePeriods-action-bookings'
    bookingsLinksWrap.style.display = 'none'
    const bookingsList = document.createElement('ul')
    bookingsList.className = 'RentFreePeriods-action-bookings-list'
    const sollLi = document.createElement('li')
    const sollBookingsLink = document.createElement('a')
    sollBookingsLink.style.display = 'none'
    sollLi.style.display = 'none'
    sollLi.appendChild(sollBookingsLink)
    const habenLi = document.createElement('li')
    const habenBookingsLink = document.createElement('a')
    habenBookingsLink.style.display = 'none'
    habenLi.style.display = 'none'
    habenLi.appendChild(habenBookingsLink)
    bookingsList.appendChild(sollLi)
    bookingsList.appendChild(habenLi)
    bookingsLinksWrap.appendChild(bookingsList)
    actionInner.appendChild(actionButtons)
    actionInner.appendChild(bookingsLinksWrap)
    actionTd.appendChild(actionInner)
    tr.appendChild(actionTd)

    if (opts.periodStart) startInput.setValue(opts.periodStart)
    if (opts.periodEnd) endInput.setValue(opts.periodEnd)
    if (opts.amountDisplay) amountInput.value = opts.amountDisplay

    tr._rentFreeRow = {
      startInput,
      endInput,
      amountInput,
      artInput,
      expenseInput,
      tenantInput,
      recurringInput,
      statusEl,
      bookingsLinksWrap,
      sollBookingsLink,
      habenBookingsLink,
      executeBtn,
      deleteBtn,
      deleteWrap,
      serverId,
      executedAt: opts.executedAt || null,
    }
    wireRowValidation(tr)
    applyRowUi(tr)
    tbody.appendChild(tr)
    refreshRentFreeEmptyState()
    runValidation()
    return tr
  }

  const addRow = () => createRentFreeDataRow({})

  const setLoadingUi = (loading) => {
    skeletonEl.style.display = loading ? 'block' : 'none'
    contentLoadedWrap.style.display = loading ? 'none' : 'block'
    addRowBtn.disabled = loading
    saveBtn.disabled = loading
  }

  const loadPeriodsFromApi = async () => {
    setLoadingUi(true)
    showValidation('')
    showWarning('')
    const token = authToken()
    try {
      const catalog = await ensureAccountCatalog()
      if (!token) {
        tbody.querySelectorAll('tr[data-rent-free-row]').forEach((el) => el.remove())
        refreshRentFreeEmptyState()
        return
      }
      const res = await fetch(
        `${apiRoot}/api/contracts/rent-free-periods?contract_id=${encodeURIComponent(unitContractId)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (!res.ok) throw new Error('load failed')
      const data = await res.json()
      const periods = Array.isArray(data.periods) ? data.periods : []
      tbody.querySelectorAll('tr[data-rent-free-row]').forEach((el) => el.remove())
      const ph = tbody.querySelector(`tr[${PLACEHOLDER_ROW_ATTR}]`)
      if (ph) ph.remove()
      periods.forEach((p) => {
        createRentFreeDataRow({
          serverId: p.id,
          periodStart: p.periodStart || p.period_start || '',
          periodEnd: p.periodEnd || p.period_end || '',
          amountDisplay: formatEuroDisplay(p.amountEur != null ? p.amountEur : p.amount_eur),
          expenseAccountCode: p.expenseAccountCode || p.expense_account_code || DEFAULT_EXPENSE_CODE,
          tenantAccountCode:
            p.tenantAccountCode ||
            p.tenant_account_code ||
            catalog?.autoTenantCode ||
            '',
          recurringMonthly: !!(p.recurringMonthly ?? p.recurring_monthly),
          executedAt: p.executedAt || p.executed_at || null,
        })
      })
      refreshRentFreeEmptyState()
      showValidation('')
      refreshAllBookingsLinks()
      runValidation()
    } catch (e) {
      console.error('rent-free-periods load', e)
      showValidation('Daten konnten nicht geladen werden.')
      refreshRentFreeEmptyState()
    } finally {
      setLoadingUi(false)
    }
  }

  addRowBtn.addEventListener('click', () => addRow())

  saveBtn.addEventListener('click', async () => {
    const result = runValidation()
    if (!result.ok) return
    const token = authToken()
    if (!token) {
      alert('Nicht angemeldet.')
      return
    }
    const rows = getDataRows()
    for (const tr of rows) {
      const row = tr._rentFreeRow
      if (row.executedAt) continue
      const built = buildRowSaveBody(row)
      if (!built.ok) {
        showValidation(built.message)
        return
      }
    }

    saveBtn.disabled = true
    try {
      for (const tr of rows) {
        const row = tr._rentFreeRow
        if (row.executedAt) continue
        const saved = await persistRow(row, token)
        if (!saved.ok) {
          showValidation(saved.message)
          return
        }
        applyRowUi(tr)
      }
      showValidation('')
    } catch (e) {
      console.error('rent-free-periods save', e)
      showValidation('Speichern fehlgeschlagen.')
    } finally {
      saveBtn.disabled = false
    }
  })

  const closeSectionDom = (wc) => {
    wc.classList.remove('section-wrapper-open')
    const content = wc.querySelector(':scope > .section-content')
    const foot = wc.querySelector(':scope > .section-footer')
    if (content) content.style.display = 'none'
    if (foot) foot.style.display = 'none'
  }

  const closeOtherPrimarySections = (exceptWrapper) => {
    pageContent.querySelectorAll(':scope > .PrimarySectionWrapper > .section-wrapper-content').forEach((wc) => {
      if (wc === exceptWrapper) return
      if (!wc.classList.contains('section-wrapper-open')) return
      closeSectionDom(wc)
    })
  }

  let didLoadPeriods = false

  const applyOpenState = (open) => {
    isOpen = open
    if (open) {
      closeOtherPrimarySections(wrapperContent)
      wrapperContent.classList.add('section-wrapper-open')
      sectionBody.style.display = ''
      footer.style.display = ''
      if (!didLoadPeriods) {
        didLoadPeriods = true
        setLoadingUi(true)
        loadPeriodsFromApi()
      }
    } else {
      wrapperContent.classList.remove('section-wrapper-open')
      sectionBody.style.display = 'none'
      footer.style.display = 'none'
    }
  }

  const toggle = () => applyOpenState(!isOpen)

  const onOtherSectionHeaderClick = (e) => {
    const headerEl = e.target.closest('.section-header')
    if (!headerEl) return
    const clickedWrapper = headerEl.closest('.section-wrapper-content')
    if (!clickedWrapper || clickedWrapper === wrapperContent) return
    if (isOpen) applyOpenState(false)
  }
  pageContent.addEventListener('click', onOtherSectionHeaderClick, true)

  header.addEventListener('click', (e) => {
    e.preventDefault()
    toggle()
  })
  header.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggle()
    }
  })

  if (!document.getElementById('RentFreePeriods-table-styles')) {
    const st = document.createElement('style')
    st.id = 'RentFreePeriods-table-styles'
    st.textContent = `
      #RentFreePeriodsTable .RentFreePeriods-table-scroll {
        /* Do not set overflow-x:auto here: with one axis non-visible, the other
           becomes auto and clips in-cell lux-picker calendars. Horizontal scroll
           is handled by the section when needed; picker portals to body. */
        overflow: visible !important;
        max-height: none !important;
      }
      #RentFreePeriods .RentFreePeriods-loaded {
        overflow-x: auto;
        overflow-y: visible;
      }
      #RentFreePeriods .section-content.section-content-with-padding {
        overflow: visible !important;
      }
      #RentFreePeriodsTable .lux-picker-dropdown { z-index: 12000; }
      #RentFreePeriodsTable .ant-table-container,
      #RentFreePeriodsTable .ant-table-body,
      #RentFreePeriodsTable table,
      #RentFreePeriodsTable thead,
      #RentFreePeriodsTable tbody,
      #RentFreePeriodsTable tr,
      #RentFreePeriodsTable th,
      #RentFreePeriodsTable td {
        background-color: #fff !important;
      }
      #RentFreePeriodsTable thead th {
        position: sticky;
        top: 0;
        box-shadow: inset 0 -1px 0 #f0f0f0;
        white-space: nowrap;
      }
      #RentFreePeriodsTable td.ant-table-cell {
        vertical-align: middle;
      }
      #RentFreePeriodsTable .ant-form-item {
        margin-bottom: 0 !important;
      }
      #RentFreePeriodsTable .ant-form-item-control-input {
        min-height: 32px;
      }
      #RentFreePeriodsTable .lux-picker,
      #RentFreePeriodsTable .RentFreePeriods-amount-field,
      #RentFreePeriodsTable .RentFreePeriods-account-select {
        box-sizing: border-box;
        height: 32px;
        min-height: 32px;
        max-height: 32px;
        padding: 4px 11px;
        border: 1px solid rgb(238, 237, 237);
        border-radius: 6px;
        background-color: #fff;
        font-size: 13px;
        line-height: 22px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.88);
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      #RentFreePeriodsTable tr:not(.RentFreePeriods-row-executed) .lux-picker:hover:not(.lux-picker-disabled),
      #RentFreePeriodsTable tr:not(.RentFreePeriods-row-executed) .RentFreePeriods-amount-field:hover,
      #RentFreePeriodsTable tr:not(.RentFreePeriods-row-executed) .RentFreePeriods-account-select:hover:not(:disabled) {
        border-color: #000;
      }
      #RentFreePeriodsTable .lux-picker.lux-picker-focused:not(.lux-picker-disabled),
      #RentFreePeriodsTable tr:not(.RentFreePeriods-row-executed) .RentFreePeriods-amount-field:focus-within,
      #RentFreePeriodsTable .RentFreePeriods-account-select:focus,
      #RentFreePeriodsTable .RentFreePeriods-account-select:focus-visible {
        border-color: #000;
        box-shadow: none;
        outline: none;
      }
      #RentFreePeriodsTable .RentFreePeriods-cell-error .lux-picker,
      #RentFreePeriodsTable .RentFreePeriods-account-input-error {
        border-color: #ff4d4f !important;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.15);
      }
      #RentFreePeriodsTable tr.RentFreePeriods-row-executed .lux-picker,
      #RentFreePeriodsTable tr.RentFreePeriods-row-executed .RentFreePeriods-amount-field,
      #RentFreePeriodsTable tr.RentFreePeriods-row-executed .RentFreePeriods-account-select:disabled {
        background-color: rgb(238, 237, 237) !important;
        border-color: rgb(238, 237, 237) !important;
        box-shadow: none !important;
        color: rgba(0, 0, 0, 0.88);
        cursor: not-allowed;
        opacity: 1;
      }
      #RentFreePeriodsTable tr.RentFreePeriods-row-executed .RentFreePeriods-amount-input:disabled {
        background-color: transparent !important;
        color: rgba(0, 0, 0, 0.88);
        -webkit-text-fill-color: rgba(0, 0, 0, 0.88);
        opacity: 1;
      }
      #RentFreePeriodsTable tr.RentFreePeriods-row-executed .RentFreePeriods-account-select:disabled {
        -webkit-text-fill-color: rgba(0, 0, 0, 0.88);
        opacity: 1;
      }
      #RentFreePeriodsTable td.RentFreePeriods-status-td {
        overflow: hidden;
      }
      #RentFreePeriodsTable td.RentFreePeriods-actions-td {
        vertical-align: middle;
        overflow: hidden;
      }
      #RentFreePeriodsTable .RentFreePeriods-actions-inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 4px;
        max-width: 100%;
        min-width: 0;
      }
      #RentFreePeriodsTable .RentFreePeriods-actions-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 4px;
        flex-wrap: nowrap;
        max-width: 100%;
      }
      #RentFreePeriodsTable .RentFreePeriods-actions-buttons .ant-btn {
        flex-shrink: 0;
        height: 28px;
        min-width: 28px;
        padding: 0 8px;
        font-size: 13px;
        line-height: 1;
      }
      #RentFreePeriodsTable .RentFreePeriods-actions-buttons .ant-btn.icon-button {
        width: 28px;
        padding: 0;
      }
      #RentFreePeriodsTable .RentFreePeriods-action-bookings {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        max-width: 100%;
        min-width: 0;
        margin-top: 2px;
      }
      #RentFreePeriodsTable .RentFreePeriods-action-bookings-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 4px;
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }
      #RentFreePeriodsTable .RentFreePeriods-action-bookings-list li {
        margin: 0;
        padding: 0;
        max-width: 100%;
        min-width: 0;
      }
      #RentFreePeriodsTable .RentFreePeriods-bookings-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
        padding: 3px 8px;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        background: #fff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.88);
        font-size: 13px;
        line-height: 1.35;
        text-decoration: none;
        transition: border-color 0.15s, box-shadow 0.15s;
      }
      #RentFreePeriodsTable .RentFreePeriods-bookings-chip:hover {
        border-color: #91caff;
        box-shadow: 0 1px 4px rgba(22, 119, 255, 0.12);
        text-decoration: none;
      }
      #RentFreePeriodsTable .RentFreePeriods-bookings-chip-side {
        flex-shrink: 0;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.65);
      }
      #RentFreePeriodsTable .RentFreePeriods-bookings-chip-code {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #1677ff;
        font-weight: 500;
      }
      #RentFreePeriodsTable .RentFreePeriods-status {
        display: inline-block;
        max-width: 100%;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
      }
      #RentFreePeriodsTable .RentFreePeriods-status-done {
        background: #d9f7be;
        color: #389e0d;
      }
      #RentFreePeriodsTable .RentFreePeriods-status-open {
        background: #fff1b8;
        color: #d48806;
      }
      #RentFreePeriodsTable .RentFreePeriods-status-draft {
        background: #f0f0f0;
        color: rgba(0, 0, 0, 0.45);
      }
      #RentFreePeriodsTable .RentFreePeriods-accounts-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
        flex-wrap: nowrap;
        min-width: 0;
      }
      #RentFreePeriodsTable .RentFreePeriods-account-input {
        flex: 1 1 0;
        width: 0;
        min-width: 0;
        font-size: 13px;
      }
      #RentFreePeriodsTable .RentFreePeriods-account-select {
        padding: 4px 28px 4px 11px;
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23000000' fill-opacity='0.45' d='M2.5 4.5L6 8l3.5-3.5'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 8px center;
        background-size: 12px;
      }
      #RentFreePeriodsTable .RentFreePeriods-account-select:disabled {
        cursor: not-allowed;
      }
      #RentFreePeriods .RentFreePeriods-skeleton {
        padding: 4px 0 8px;
      }
      #RentFreePeriods .RentFreePeriods-skeleton-toolbar {
        display: flex;
        margin-bottom: 12px;
      }
      #RentFreePeriods .RentFreePeriods-skeleton-bar {
        background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 37%, #f0f0f0 63%);
        background-size: 400% 100%;
        animation: RentFreePeriods-skeleton-shimmer 1.4s ease infinite;
        border-radius: 6px;
      }
      @keyframes RentFreePeriods-skeleton-shimmer {
        0% { background-position: 100% 50%; }
        100% { background-position: 0 50%; }
      }
      #RentFreePeriodsTable .RentFreePeriods-accounts-arrow {
        flex-shrink: 0;
        color: rgba(0, 0, 0, 0.45);
        font-size: 13px;
        line-height: 1;
      }
      #RentFreePeriodsTable .RentFreePeriods-delete-wrap {
        display: inline-flex;
      }
      #RentFreePeriodsTable tr.ant-table-placeholder td.ant-table-cell {
        border-bottom: none;
        padding: 32px 16px;
        text-align: center;
      }
      #RentFreePeriodsTable .EmptyTableMultilineMessageContainer .ant-empty-description .description {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        line-height: 1.5715;
      }
      #RentFreePeriodsTable .DateInput {
        width: 100%;
      }
      #RentFreePeriodsTable .lux-picker,
      #RentFreePeriodsTable .lux-picker input,
      #RentFreePeriodsTable .lux-picker-mask,
      #RentFreePeriodsTable .DateInput input,
      #RentFreePeriodsTable .RentFreePeriods-amount-input,
      #RentFreePeriodsTable .RentFreePeriods-account-select {
        font-size: 13px !important;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.88);
        font-family: inherit;
      }
      #RentFreePeriodsTable .RentFreePeriods-amount-field {
        display: flex;
        align-items: center;
        width: 100%;
        overflow: hidden;
      }
      #RentFreePeriodsTable .RentFreePeriods-amount-input {
        flex: 1 1 0;
        width: 0;
        min-width: 0;
        border: 0 !important;
        box-shadow: none !important;
        text-align: right;
        outline: none;
        background: transparent;
        line-height: 22px;
        font-variant-numeric: tabular-nums;
        padding: 0;
        height: 22px;
      }
      #RentFreePeriodsTable .RentFreePeriods-amount-suffix {
        flex-shrink: 0;
        color: rgba(0, 0, 0, 0.45);
        padding: 0 0 0 4px;
        font-size: 13px;
        line-height: 22px;
        font-weight: 500;
        user-select: none;
      }
    `
    document.head.appendChild(st)
  }

  wrapperContent.appendChild(header)
  wrapperContent.appendChild(sectionBody)
  wrapperContent.appendChild(footer)
  root.appendChild(wrapperContent)
  root._rentFreePeriodsRefreshEmpty = refreshRentFreeEmptyState
  root._rentFreePeriodsReload = loadPeriodsFromApi
  pageContent.appendChild(root)
}
